/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import Grid from '../../../containers/dashboard/grid';
import Task from '../../../containers/task/stock';
import {getTaskColumns, getTaskColumnsAndTasksDone, getTasksReserved} from '../../../store/tasks/selectors';
import {isQuality} from "../../../store/auth/selectors";
import {getworkstepcount} from "../../../store/tasks/actions";

class DoneGrid extends React.Component {
    componentDidMount() {

        const {getworkstepcount} = this.props;
        getworkstepcount()
    }
    render() {
        const {tasks, columns} = this.props.taskColums;
        let allowedStatuses = ['none'];
        return (
            <Grid
                tasks={tasks}
                columns={columns}
                taskComponent={Task}
                allowedStatuses={allowedStatuses}
            />
        );
    }
}

export default connect(
    state => ({
        taskColums : getTaskColumnsAndTasksDone(state),
        tasks: getTasksReserved(state),
        columns: getTaskColumns(state, getTasksReserved),
        isQuality: isQuality(state),
    }), {getworkstepcount}
)(DoneGrid);



// WEBPACK FOOTER //
// ./src/containers/dashboard/grid/done.js